import {
  SfSelectData,
  SfSelectFormField,
  SfSelectOption,
} from 'ngx-smart-form';
import {
  COUNTRIES,
  getCountriesOptions,
} from '../../../assets/aml-config/countries';
import { IFormField } from 'ngx-smart-form/lib/smart-form/interfaces/i-form-field';

export class AreaGeograficaField extends SfSelectFormField<
  {
    areaGeograficaAttivita: string;
  },
  string | undefined
> {
  constructor(
    fieldSettings: Partial<IFormField<{ areaGeograficaAttivita: string }>> &
      SfSelectData
  ) {
    super({
      formControlName: 'areaGeograficaAttivita',
      label:
        fieldSettings?.label || "Area geografica di svolgimento dell'attività",
      required: fieldSettings?.required || false,
      options: getCountriesOptions(),
      value: fieldSettings?.value || undefined,
      isMulti: fieldSettings?.isMulti || true,
      ...fieldSettings,
    });
  }
}
